import React, { useState, useEffect } from "react";
import backgroundImage from "../assets/background.png";
import volunteerHands from "../assets/volunteerHands.png";
import VolunteerForm from "./volunteerForm";
import Newsletter from "./newsLetter";
import TestimonialsSection from "./testimonials";

const Volunteer = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  // const [ourLeaders, setOurLeaders] = useState([]);
  // const [loadingLeaders, setLoadingLeaders] = useState(false);
  const [volunteerOpportunities, setVolunteerOpprtunities] = useState([]);
  const [loadingVol, setLoadingVol] = useState(false);
  const [clickedCardIndex, setClickedCardIndex] = useState(null);

  const handleSvgClick = (index) => {
    setClickedCardIndex(clickedCardIndex === index ? null : index);
  };

  const handleOpenForm = () => {
    setIsFormVisible(true);
  };

  const handleCloseForm = () => {
    setIsFormVisible(false);
  };

  useEffect(() => {
    // const fetchLeaders = async () => {
    //   try {
    //     setLoadingLeaders(true);
    //     const response = await fetch(
    //       `${process.env.REACT_APP_BASE_URL}/api/board-officers?populate=*`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
    //         },
    //       }
    //     );
    //     const data = await response.json();
    //     setOurLeaders(data.data);
    //   } catch (error) {
    //     console.error("Error fetching staffs:", error);
    //   } finally {
    //     setLoadingLeaders(false);
    //   }
    // };

    const fetchVolunteers = async () => {
      try {
        setLoadingVol(true);
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/job-postings?populate=*`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        setVolunteerOpprtunities(data.data);
      } catch (error) {
        console.error("Error fetching volunteer opportunities:", error);
      } finally {
        setLoadingVol(false);
      }
    };

    // fetchLeaders();
    fetchVolunteers();
  }, []);

  const circleStyles = {
    width: "24px",
    height: "24px",
    background: "rgba(255, 165, 0, 1)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  };

  const checkmarkSVG = (
    <svg
      width="10"
      height="8"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: "absolute" }}
    >
      <path
        d="M1 5L4 8L11 1"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <>
      <div
        className="min-h-screen flex flex-col items-center px-4  relative z-10"
        style={{ marginTop: "85px" }}
      >
        <div
          className="relative bg-cover bg-center w-full flex items-center justify-center py-16"
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: "50% 1%",
          }}
        >
          <div className="text-center max-w-3xl mx-auto bg-opacity-80 p-8 rounded-lg">
            <h1
              className="text-custom-blue text-[32px] md:text-[64px] font-bold leading-[38.4px] md:leading-[76.8px] text-center"
              style={{ fontFamily: "Manrope", fontWeight: "700" }}
            >
              Become a Leader with Faith Coalition
            </h1>
            <p
              className="text-black mt-4 text-[14px] md:text-[18px] font-normal leading-[20px] md:leading-[25.6px] text-center"
              style={{ fontFamily: "Manrope", fontWeight: "400" }}
            >
              Join us in making a difference in our community through your time
              and talents
            </p>
          </div>
        </div>

        <div className="flex justify-center mt-12 px-4 md:px-0">
          <img
            src={volunteerHands}
            alt="Volunteer Hands"
            className="w-full max-w-3xl md:max-w-4xl h-auto"
            style={{
              width: "100%",
              maxWidth: "862px",
              height: "auto",
            }}
          />
        </div>

        
        {/* <div className="w-full max-w-[1440px] pt-[50px] mx-auto">
          <div className="w-full max-w-[1200px] mx-auto flex flex-col items-center mb-[32px] px-4 md:px-0">
            <div className="flex justify-center w-full">
              <h2 className="text-[32px] font-semibold leading-[38.4px] text-[#002A57] text-center">
                Meet Our Leaders
              </h2>
            </div>

       
          </div>
          <div className="w-full max-w-[1200px] mx-auto mt-12 px-4">
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
              {loadingLeaders && (
                <div className="flex col-span-full justify-center items-center text-custom-blue">
                  <svg
                    className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-custom-orange rounded-full"
                    viewBox="0 0 24 24"
                  ></svg>
                  Loading leaders...
                </div>
              )}
              {ourLeaders.map((staff, index) => (
                <div
                  key={index}
                  className="w-full flex flex-col items-start gap-2 group transition-transform duration-300 ease-in-out transform hover:scale-105 relative"
                >
                  <div className="w-full h-[320px] overflow-hidden rounded-[20px] relative">
                    <img
                      src={staff.attributes.headshot.data.attributes.url}
                      alt={staff.attributes.name}
                      className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition duration-500"
                    />
                    <div className="absolute bottom-7 right-4 flex flex-col items-end">
                      <div
                        className={`relative transform transition-all duration-500 ${
                          clickedCardIndex === index
                            ? "translate-y-0 opacity-100"
                            : "translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100"
                        }`}
                      >
                        <button
                          onClick={() => handleSvgClick(index)}
                          className="focus:outline-none w-8 h-8 flex items-center justify-center bg-[#F1AE45] rounded-full"
                        >
                          <span className="block relative w-4 h-4 bg-transparent transition-transform duration-300">
                   
                            <span
                              className={`absolute left-0 top-1/2 w-full h-[1.2px] bg-[#002A57] transform -translate-y-1/2 ${
                                clickedCardIndex === index ? "rotate-45" : ""
                              } transition-transform duration-300`}
                            ></span>
                  
                            <span
                              className={`absolute left-1/2 top-0 h-full w-[1.2px] bg-[#002A57] transform -translate-x-1/2 ${
                                clickedCardIndex === index ? "rotate-45" : ""
                              } transition-transform duration-300`}
                            ></span>
                          </span>
                        </button>

          
                        <div
                          className={`absolute -top-[70px] right-0 w-[30px] h-[61px] bg-white transform ${
                            clickedCardIndex === index
                              ? "translate-y-0 opacity-100"
                              : "translate-y-4 opacity-0"
                          } transition-all duration-500`}
                          style={{
                            padding: "11px 8px",
                            borderRadius: "8px 8px 8px 8px",
                          }}
                        >
                          <div className="flex flex-col items-center">
                   
                            <a
                              href={`mailto:${staff.email}`}
                              className="w-[14px] h-[14px]"
                            >
           
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1656_2629)">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.29493 10.5701C4.7249 10.5701 5.93467 11.5129 6.3366 12.8107C6.40722 13.0388 6.36883 13.2656 6.22719 13.4578C6.08555 13.6499 5.8802 13.7537 5.64149 13.7537H0.948399C0.709689 13.7537 0.50431 13.6499 0.362669 13.4578C0.221028 13.2656 0.182638 13.0388 0.253267 12.8107C0.655192 11.5129 1.86499 10.5701 3.29493 10.5701ZM7.37385 0.269456C9.06001 0.475929 10.2595 2.01021 10.053 3.69634C9.84658 5.38249 8.31229 6.58201 6.62614 6.37553C6.10417 6.31163 5.62891 6.12036 5.22748 5.83683L4.28781 6.25093C4.23583 6.27384 4.1783 6.26353 4.13753 6.224C4.09676 6.18446 4.08465 6.12728 4.10592 6.07462L4.49609 5.10873C4.06479 4.50459 3.8496 3.74351 3.94694 2.94862C4.15341 1.2625 5.6877 0.0629837 7.37385 0.269456ZM6.9964 3.02171C6.83029 3.02171 6.69562 3.15638 6.69562 3.3225C6.69562 3.48861 6.83029 3.62328 6.9964 3.62328C7.16251 3.62328 7.29718 3.48861 7.29718 3.3225C7.29718 3.15638 7.16251 3.02171 6.9964 3.02171ZM5.53805 3.02171C5.37193 3.02171 5.23727 3.15638 5.23727 3.3225C5.23727 3.48861 5.37193 3.62328 5.53805 3.62328C5.70419 3.62328 5.83883 3.48861 5.83883 3.3225C5.83883 3.15638 5.70416 3.02171 5.53805 3.02171ZM8.46197 3.02171C8.29586 3.02171 8.16119 3.15638 8.16119 3.3225C8.16119 3.48861 8.29586 3.62328 8.46197 3.62328C8.62808 3.62328 8.76275 3.48861 8.76275 3.3225C8.76275 3.15638 8.62808 3.02171 8.46197 3.02171ZM10.7051 6.92088C11.5941 6.92088 12.3147 7.64152 12.3147 8.5305C12.3147 9.41947 11.5941 10.1401 10.7051 10.1401C9.81614 10.1401 9.0955 9.41947 9.0955 8.5305C9.09547 7.64155 9.81614 6.92088 10.7051 6.92088ZM10.7051 10.5701C12.1351 10.5701 13.3448 11.5129 13.7468 12.8107C13.8174 13.0388 13.779 13.2656 13.6373 13.4578C13.4957 13.6499 13.2904 13.7537 13.0516 13.7537H8.35856C8.11984 13.7537 7.91447 13.6499 7.77283 13.4578C7.63119 13.2656 7.59279 13.0388 7.66342 12.8107C8.06532 11.5129 9.27515 10.5701 10.7051 10.5701ZM3.29496 6.92088C4.18393 6.92088 4.90458 7.64152 4.90458 8.5305C4.90458 9.41947 4.1839 10.1401 3.29496 10.1401C2.40599 10.1401 1.68534 9.41947 1.68534 8.5305C1.68534 7.64155 2.40599 6.92088 3.29496 6.92088Z"
                                    fill="#002A57"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1656_2629">
                                    <rect width="14" height="14" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </a>

             
                            <a
                              href={staff.linkedin}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="w-[14px] h-[14px]"
                              style={{ marginTop: "14px" }}
                            >
    
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.83755 4.90001C8.39045 4.89848 7.94745 4.98512 7.53387 5.15498C7.1203 5.32483 6.74427 5.57457 6.42731 5.8899C6.11036 6.20523 5.85869 6.57997 5.68671 6.99266C5.51473 7.40536 5.42581 7.84792 5.42505 8.29501V11.725C5.42505 11.8643 5.48036 11.9978 5.57882 12.0962C5.67727 12.1947 5.81081 12.25 5.95005 12.25H7.17505C7.31429 12.25 7.44782 12.1947 7.54628 12.0962C7.64474 11.9978 7.70005 11.8643 7.70005 11.725V8.29501C7.69993 8.136 7.73333 7.97874 7.79807 7.8335C7.8628 7.68826 7.95742 7.55829 8.07575 7.45206C8.19408 7.34584 8.33348 7.26575 8.48484 7.217C8.6362 7.16826 8.79613 7.15197 8.95422 7.16918C9.23772 7.20489 9.49826 7.3434 9.68642 7.55845C9.87459 7.77349 9.97729 8.05011 9.97505 8.33585V11.725C9.97505 11.8643 10.0304 11.9978 10.1288 12.0962C10.2273 12.1947 10.3608 12.25 10.5 12.25H11.725C11.8643 12.25 11.9978 12.1947 12.0963 12.0962C12.1947 11.9978 12.25 11.8643 12.25 11.725V8.29501C12.2493 7.84792 12.1604 7.40536 11.9884 6.99266C11.8164 6.57997 11.5647 6.20523 11.2478 5.8899C10.9308 5.57457 10.5548 5.32483 10.1412 5.15498C9.72765 4.98512 9.28464 4.89848 8.83755 4.90001Z"
                                  fill="#002A57"
                                />
                                <path
                                  d="M3.85 5.42499H2.275C1.98505 5.42499 1.75 5.66004 1.75 5.94999V11.725C1.75 12.0149 1.98505 12.25 2.275 12.25H3.85C4.13995 12.25 4.375 12.0149 4.375 11.725V5.94999C4.375 5.66004 4.13995 5.42499 3.85 5.42499Z"
                                  fill="#002A57"
                                />
                                <path
                                  d="M3.0625 4.375C3.78737 4.375 4.375 3.78737 4.375 3.0625C4.375 2.33763 3.78737 1.75 3.0625 1.75C2.33763 1.75 1.75 2.33763 1.75 3.0625C1.75 3.78737 2.33763 4.375 3.0625 4.375Z"
                                  fill="#002A57"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full font-primary text-xl sm:text-2xl font-semibold leading-snug text-center sm:text-left text-[#002A57]">
                    {staff.attributes.name}
                  </div>
                  <div className="w-full font-secondary text-base sm:text-lg font-normal leading-snug text-center sm:text-left text-[#002A57]">
                    {staff.attributes.role}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        <div
          className="relative mt-16 bg-white p-4 md:p-8 lg:p-16 flex flex-col items-center justify-center"
          style={{
            width: "100%",
            maxWidth: "1200px",
            height: "auto",
          }}
        >
          <h1
            className="text-center"
            style={{
              fontFamily: "Manrope",
              fontSize: "32px",
              fontWeight: 700,
              lineHeight: "38.4px",
              textAlign: "center",
              color: "rgba(0, 42, 87, 1)",
            }}
          >
            Volunteer Opportunities
          </h1>
          <p
            className="text-center mt-4 md:mt-0"
            style={{
              fontFamily: "Open Sans",
              fontSize: "18px",
              fontWeight: 400,
              lineHeight: "28.8px",
              textAlign: "center",
              color: "rgba(67, 62, 63, 1)",
              maxWidth: "585px",
            }}
          >
            Below you will find a list of volunteer opportunities that are
            typically available. Click on the button below to sign up and become
            a volunteer.
          </p>
          <div className="flex flex-col md:flex-row justify-between w-full px-2 mt-8 space-y-4 md:space-y-0 md:space-x-4">
            {loadingVol && (
              <div className="flex w-full justify-center items-center text-custom-blue">
                <svg
                  className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-custom-orange rounded-full"
                  viewBox="0 0 24 24"
                ></svg>
                Loading opportunities...
              </div>
            )}
            <div className="flex flex-col items-start w-full md:w-1/2">
              {volunteerOpportunities
                .slice(0, Math.ceil(volunteerOpportunities.length / 2))
                .map((opportunity, index) => (
                  <div
                    key={index}
                    className="flex items-center mt-2"
                    style={{ gap: "16px", height: "28px" }}
                  >
                    <span style={circleStyles}>{checkmarkSVG}</span>
                    <span
                      style={{
                        fontFamily: "Manrope",
                        fontSize: "18px",
                        fontWeight: 400,
                        lineHeight: "28px",
                        color: "rgba(67, 62, 63, 1)",
                      }}
                    >
                      {opportunity.attributes.Listing}
                    </span>
                  </div>
                ))}
            </div>
            <div className="flex flex-col items-start w-full md:w-1/2">
              {volunteerOpportunities
                .slice(Math.ceil(volunteerOpportunities.length / 2))
                .map((opportunity, index) => (
                  <div
                    key={index}
                    className="flex items-center mt-2"
                    style={{ gap: "16px", height: "28px" }}
                  >
                    <span style={circleStyles}>{checkmarkSVG}</span>
                    <span
                      style={{
                        fontFamily: "Manrope",
                        fontSize: "18px",
                        fontWeight: 400,
                        lineHeight: "28px",
                        color: "rgba(67, 62, 63, 1)",
                      }}
                    >
                      {opportunity.attributes.Listing}
                    </span>
                  </div>
                ))}
            </div>
          </div>
          <button
            className="w-[190px] h-[48px] bg-[#002A57] text-white rounded-full p-3 focus:outline-none focus:ring-2 focus:ring-custom-blue mt-8"
            style={{
              fontFamily: "Manrope",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "18px",
              color: "rgba(255, 255, 255, 1)",
            }}
            onClick={handleOpenForm}
          >
            Become a Volunteer
          </button>
        </div>
        <VolunteerForm isVisible={isFormVisible} onClose={handleCloseForm} />
      </div>
      <TestimonialsSection />
      <Newsletter />
    </>
  );
};

export default Volunteer;
